import { useContext } from "react";
import styles from "./AboutUs.module.css";
import DataContext from "../../../store/data-context";

export default function AboutUs() {
  const dataCtx = useContext(DataContext);

  return (
    <>
      <div className={styles.id} id="about_us"></div>
      <main className={styles.main}>
        <div className={styles.info}>
          <div className={styles.title}>{dataCtx.pageData.about_us.title}</div>
          <div
            className={styles.text}
            dangerouslySetInnerHTML={{
              __html: dataCtx.pageData.about_us.info,
            }}
          ></div>
        </div>
        <img
          className={styles.image}
          src={dataCtx.pageData.about_us.image}
          alt="Image."
        />
      </main>
    </>
  );
}
